<template>
  <button class="info-icon" @click.prevent.stop="handleClick" @tap.prevent.stop="handleClick">i</button>
</template>

<script>
export default {
  name: 'info-icon',
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss">
.info-icon {
  @include button-reset;
  font-family: $font-family-info-icon;
  font-weight: $font-weight-info-icon;

  background: $color-background-info-icon-base;
  color: $color-text-info-icon-base;
  transition: $time-transition-global-base;
  padding: 0;
  &:hover {
    background: $color-background-info-icon-hover;
  color: $color-text-info-icon-hover;
  }
  &:focus {
    background: $color-background-info-icon-focus;
  color: $color-text-info-icon-focus;
  }

  height: $size-height-info-icon-base;
  width: $size-width-info-icon-base;
  font-size: $size-text-info-icon-base;
  border-radius: $size-border-radius-info-icon-base;
}
</style>
